export enum PDFViewerMode {
    Auto = 0,
    Object = 1,
    PDFJS = 2
}

export enum PDFZoomPreset {
    PageWidth = "page-width",
    PageHeight = "page-actual",
    PageFit = "page-fit",
    Auto = "auto"
}
